module.exports = __webpack_public_path__ + "static/videos-hero-35423ad14a49abadea6710b0234b3409.jpg";